import { render, staticRenderFns } from "./Publicacao.vue?vue&type=template&id=d7a20d4c&"
import script from "./Publicacao.vue?vue&type=script&lang=js&"
export * from "./Publicacao.vue?vue&type=script&lang=js&"
import style0 from "./Publicacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports